import { ServiceRequest } from "../utils/service-request"
import {
    MOTOR_CADASTRO_PATH,
    MOTOR_CADASTRO_TEMPORARIO_PATH
} from "../utils/api-routes"

class MotorPremioService {
    constructor() {
        this.request = new ServiceRequest()
    }

    // Temporario
    async getTemporarioPremio(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/premio`
        return this.request.get(path)
    }

    async createCadastroTemporarioPremio(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/premio`
        return this.request.post(path, payload)
    }

    async deleteCadastroTemporarioPremio(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/premio`
        return this.request.delete(path)
    }

    // Producao
    async getPremio(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/premio`
        return this.request.get(path)
    }

    async createCadastroPremio(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/premio`
        return this.request.post(path, payload)
    }

    async updateCadastroPremio(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/premio`
        return this.request.put(path, payload)
    }

    async deleteCadastroPremio(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/premio`
        return this.request.delete(path)
    }
}

export default MotorPremioService